<template>
    <a-modal title="修改密码"
             :width="600"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="confirmPassword"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-form :form="form" class="form1">
            <a-form-item label="旧密码">
                <a-input type="password"
                         placeholder = '请输入旧密码'
                         v-decorator="['oldPassword', {rules: [{required: true, message: '旧不能为空' }]}]"/>
            </a-form-item>
            <a-form-item label="新密码">
                <a-input type="password"
                         placeholder = '6-20位字符,需含数字、大小写字母、下划线中的两种或以上'
                         v-decorator="['password', {rules: [{required: true, message: '新密码不能为空' },{pattern:  /^(?![\d]+$)(?![a-zA-Z]+$)(?![_]+$)[\da-zA-Z_]{6,18}$/,message:'密码必须是6-20位数字、大小写字母、下划线中的两种或以上'}]}]"/>
            </a-form-item>
            <a-form-item label="确认密码">
                <a-input type="password"
                         placeholder = '请输入确认密码'
                         v-decorator="['password2', {rules: [{ required: true, message: '确认密码不能为空' }]}]"
                />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'


    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                userName: '',
                orgName: '',
                actions: [
                    {type: 'bank', text: '广东省环境监测中心'},
                    {type: 'clock-circle', text: '发布时间：今天10: 30 '},
                ],
                id: this.$route.query.id,
                modalLoading: false,
                params: {},
                loading: false,
                account: ''
            }
        },
        methods: {
            ...mapActions(['Logout']),
            ...mapGetters(['nickname', 'avatar']),
            handleLogout() {
                const that = this
                return that.Logout({}).then(() => {
                }).catch(err => {
                    that.$message.error({
                        title: '错误',
                        description: err.message
                    })
                })
            },
            initInfo(id) {
                let that = this
                this.$http.get('/api/v1/supplier/account/get_account_info.json?id='+id).then(function (res) {
                    that.account = res.result.account
                })
            },
            onSubmit() {
                let params = {...this.form.getFieldsValue()}
                if (!params.oldPassword) {
                    this.$message.error("旧密码不能为空")
                    return;
                }
                if (!params.password) {
                    this.$message.error("密码不能为空")
                    return;
                }
                if (params.password !== params.password2) {
                    this.$message.error('确认密码不正确!');
                    return;
                }
                let that = this
                params.id = this.account.id
                console.log('密码修改')
                that.modalLoading = true
                this.$http.post("/api/v1/supplier/account/edit_account.json", qs.stringify(params, {allowDots: true})).then(function (res) {
                    that.modalLoading = false
                    if (res.code === 200) {
                        that.$message.success("密码修改成功!")
                        that.handleLogout()
                        // that.$router.go(0)
                    }
                })
            },
            confirmPassword () {
                let params = { ...this.form.getFieldsValue() }
                params.id = this.account.id
                if (!params.oldPassword) {
                    this.$message.error("旧密码不能为空")
                    return;
                }
                let params2 = {}
                params2.password = params.oldPassword
                params2.id = params.id
                let that = this
                this.$http.post("/api/v1/supplier/account/confirm_password.json",qs.stringify(params2, { allowDots: true })).then(function (res) {
                    if (res.result === true){
                        that.$confirm({
                            title: '提示',
                            content: '更改密码后将会退出登录,你确定要更改吗?',
                            okText: '确认',
                            okType: 'primary',
                            cancelText: '取消',
                            onOk() {
                                that.onSubmit()
                            },
                            onCancel() {
                                console.log('Cancel');
                            },
                        })
                    }else {
                        that.$message.error('旧密码不正确!')
                    }
                })
            },
            fixedAccount(rule, value, callback) {
                let params = {...this.form.getFieldsValue()}
                let params2 = {}
                params2.account = params.account
                // params2.id = this.account.id
                let that = this
                this.$http.post('/api/v1/supplier/account/validateAccount2.json',qs.stringify(params2, {allowDots: true})).then(function (res) {
                    if (res.result.length > 0) {
                        for (let i = 0; i < res.result.length; i++) {
                            if(res.result[i].id !== that.account.id) {
                                callback('该账号已存在');
                            }
                        }
                    }
                    callback();
                });

            },

        }
    };
</script>
<style lang="less" scoped>
    /deep/ .form1 .ant-form-item{
        display: flex;
    }
    /deep/ .form1 .ant-form-item-label{
        flex-grow: 0;
        flex-shrink: 0;
        width: 100px;
    }
    /deep/ .form1 .ant-form-item-control-wrapper{
        flex: 1 1 100%;
        padding-left: 20px;
    }
</style>
